export default "__VITE_ASSET__LufB_KGg__"